export default "__VITE_ASSET__yj_YGqpY__"